import { render, staticRenderFns } from "./ViolationStatisticTrends.vue?vue&type=template&id=37da4c87&scoped=true&"
import script from "./ViolationStatisticTrends.vue?vue&type=script&lang=js&"
export * from "./ViolationStatisticTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da4c87",
  null
  
)

export default component.exports